import { render, staticRenderFns } from "./modelModal.vue?vue&type=template&id=724d8d48&"
import script from "./modelModal.vue?vue&type=script&lang=js&"
export * from "./modelModal.vue?vue&type=script&lang=js&"
import style0 from "./modelModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports